var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOffSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7753906,14.6855469c-0.8850708-2.4310913-2.2689819-4.5194702-4.0276489-6.1911011l-1.4193115,1.4193115 c1.5613403,1.4699707,2.7872314,3.3110352,3.5680542,5.4553833C29.9648438,15.5585938,30,15.7705078,30,16 s-0.0351562,0.4414062-0.1035156,0.6308594C27.7919922,22.4101562,22.4677734,26,16,26 c-1.7601318,0-3.4309692-0.2744751-4.9798584-0.7779541l-1.5725098,1.5725098C11.4500122,27.578064,13.6582031,28,16,28 c7.3310547,0,13.3759766-4.0947266,15.7753906-10.6855469C31.9248047,16.9052734,32,16.4628906,32,16 S31.9248047,15.0947266,31.7753906,14.6855469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6715698,22.0862427c-1.5613403-1.4699707-2.7872314-3.3110352-3.5680542-5.4553833 C2.0351562,16.4414062,2,16.2294922,2,16s0.0351562-0.4414062,0.1035156-0.6308594C4.2080078,9.5898438,9.5322266,6,16,6 c1.7601318,0,3.4310303,0.2744141,4.9799194,0.7778931l1.5724487-1.5724487C20.5499878,4.421936,18.3417969,4,16,4 C8.6689453,4,2.6240234,8.0947266,0.2246094,14.6855469C0.0751953,15.0947266,0,15.5371094,0,16 s0.0751953,0.9052734,0.2246094,1.3144531c0.8850708,2.4310913,2.2689819,4.5194702,4.0276489,6.1911011L5.6715698,22.0862427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2694092,19.9727783l-1.8173828,1.8173828C14.9468384,21.9226074,15.4639893,22,16,22c3.3085938,0,6-2.6914062,6-6 c0-0.5360107-0.0773926-1.0531616-0.2098389-1.5479736l-1.8173828,1.8173828 C19.8374634,18.2571411,18.2571411,19.8374634,16.2694092,19.9727783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,16c0,0.5360107,0.0773926,1.0531616,0.2098389,1.5479736l1.8173828-1.8173828 c0.1353149-1.9877319,1.7156372-3.5680542,3.7033691-3.7033691l1.8173828-1.8173828C17.0531616,10.0773926,16.5360107,10,16,10 C12.6914062,10,10,12.6914062,10,16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.2132034,
    y: 15.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -6.6274171 16)",
    width: 42.4264069,
    height: 1.9997864
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffSmall);
export default __webpack_public_path__ + "static/media/eye-off--small.edac20d9876f8e72ec152ac5951818b4.svg";
export { ForwardRef as ReactComponent };